import { Coordinates } from '../models';

/**
 * https://www.movable-type.co.uk/scripts/latlong.html
 */
export function haversine(
  {lat: lat1, lng: lng1}: Coordinates,
  {lat: lat2, lng: lng2}: Coordinates,
) {
  const R = 6371e3; // metres
  const fi1 = lat1 * Math.PI/180; // in radians
  const fi2 = lat2 * Math.PI/180; // in radians
  const deltaFi = (lat2-lat1) * Math.PI/180;
  const deltaLambda = (lng2-lng1) * Math.PI/180;

  const a = Math.sin(deltaFi/2) * Math.sin(deltaFi/2) +
    Math.cos(fi1) * Math.cos(fi2) *
    Math.sin(deltaLambda/2) * Math.sin(deltaLambda/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  return R * c; // in metres
}
